import React from "react";

export default function CandidateProjects() {
  return <div>CandidateProjects</div>;
}
